import React, { Suspense } from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import { CContainer, CFade } from '@coreui/react'

// routes config
import routes from '../routes'
  
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheContent = ({style}) => {
  return (
    <main className={style?'':"c-main"}>
      <CContainer fluid
      style={style?{
padding:0
      }: {}}
      >
        <Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => {
              if(window.location === '/content/create' 
              || window.location === '/CreateLink'
              || window.location === '/NameofExercise'
              || window.location === '/PostQuestionAndAnswer'
              || window.location === '/PostQuestionAndAnswerSunEditor'
               ){
                return  0
               }
              // console.log(route.path, "PATH");
              return route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                    <CFade>
                      <route.component {...props} />
                    </CFade>
                  )} />
              )
            })}
      
      <Redirect from="/" to="/" />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  )
}

export default React.memo(TheContent)
